import { render, staticRenderFns } from "./PhenomenonGroups.vue?vue&type=template&id=6882d630&"
import script from "./PhenomenonGroups.vue?vue&type=script&lang=ts&"
export * from "./PhenomenonGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports